import React, { useState } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import { partnersLogo } from '../../../assets/partners';
import { NoImage, Trash, Edit } from '../../../assets';
import { CustomButton, CustomModal } from '../../shared';
import UploadAsset from './uploadAsset';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteCustomerSettings, getChannelAndVendor, getCustomerSettings } from '../../../redux/thunks/companyThunks'
import { getCampaignIngestion } from '../../../redux/thunks/campaignThunks';
import TableRowsSkeleton from '../../shared/skelton/tableSkelton';
import { actions } from '../../../redux/reducers/companyReducer'

function AssetsList(props) {
    const { } = props;
    const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState("Upload New Asset Here")
    const dispatch = useDispatch()
    const { customersSetting, company } = useSelector((state) => state.company)
    const { customersSettings, isLoading, isDeleted } =customersSetting
    const { campaignGenerationType } = useSelector((state) => state.campaign);
    const partnersIconMapping = (name) => {
        const brand = name?.toLowerCase();
        for (const partnerName in partnersLogo) {
            if (brand.includes(partnerName)) {
                return partnersLogo[partnerName];
            }
        }
        return null;
    };
    const handleShowModal = (e,row) => {
        if(e==="New"){
            setTitle("Upload New Asset Here")
            setShowModal(prev => !prev);
            dispatch(actions.editCustomer({data:null}))
        }
       else if(e==="Edit"){
            setTitle("Edit Asset Here")
            setShowModal(prev => !prev);
            dispatch(actions.editCustomer({data:[row]}))
       }
       else{
        setShowModal(prev => !prev);
       }
    }
    useEffect(() => {
        if(company.id){
            dispatch(getCampaignIngestion({ companyId: company.id }));
        }
    },[company.id, dispatch])
    useEffect(() => {
        if(company.id){
            dispatch(getChannelAndVendor())
        }
    },[company.id,showModal])

    useEffect(() => {
        if(company.id){
            dispatch(getCustomerSettings({companyId: company.id}))
        }
    },[company.id,showModal,isDeleted])
    

    return (
        <>
        {
            campaignGenerationType==="ALGORITHM" ? 
            <Box className="box-sizing-border-box border-1-gray br-8px">
            {/* Table Header */}
            <Box className="padding-tb-20-rl-24 border-bottom-gray">
                <Box className="flex-row-space-between-center">
                    <Box>
                        <Typography className="text-lg-medium gray-900">
                            List of Assets
                        </Typography>
                    </Box>
                    <Box>
                        <CustomButton
                            title="Upload New Asset"
                            handleClick={()=>handleShowModal("New")}
                        />
                    </Box>
                </Box>
            </Box>

            {/* Table Content */}
            <Box>
                <TableContainer component={Paper} className='no-box-shadow no-border'>
                    <Table className='table-border-collapse no-border'>
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-headers-title">Channel</TableCell>
                                <TableCell className="table-headers-title">Topic</TableCell>
                                <TableCell className="table-headers-title">Vendor</TableCell>
                                <TableCell className="table-headers-title">Subject Line</TableCell>
                                <TableCell className="table-headers-title">Content Type</TableCell>
                                <TableCell className="table-headers-title">Image</TableCell>
                                <TableCell className="table-headers-title"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? (<TableRowsSkeleton rows={6} columns={7}/>) :(customersSettings?.map((row, index) => {
                               const contentTypes = Array.isArray(row?.content_type) ? row?.content_type : JSON.parse(row?.content_type || '[]');
                                return (
                                <>
                                    <TableRow key={'asset' + index} className={index % 2 === 0 ? 'odd-row-background ' : ''}>
                                        <TableCell className='table-row-data no-border' >
                                            {row.channel}
                                        </TableCell>
                                        <TableCell className='table-row-data no-border' >
                                            {row.topic}
                                        </TableCell>
                                        <TableCell className='table-row-data no-border' >
                                            <Box className="flex-row-start-center gap-12" >
                                                <img
                                                    src={partnersIconMapping(row.vendor)}
                                                    width="40px"
                                                    height="40px"
                                                    alt={row.vendor}
                                                    className="border-1-gray br-16px"
                                                />
                                                <Typography className="text-sm-medium gray-900">
                                                    {row.vendor}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell className='table-row-data no-border' >
                                            <Box className="flex-column-center br-16px bg-gray-100 padding-tb-4-rl-12">
                                                <Typography className='text-xs-medium gray-700'>
                                                    {
                                                        contentTypes && contentTypes?.length !== 0
                                                            ? contentTypes?.map((item, index) => (
                                                                <span key={index}>
                                                                    {item?.subject_line}
                                                                    {index !== contentTypes?.length - 1 ? ', ' : ''}
                                                                </span>
                                                            ))
                                                            : ' '
                                                    }
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell className='table-row-data no-border' >
                                            {
                                                contentTypes && contentTypes?.length !== 0
                                                    ? contentTypes?.map((item, index) => (
                                                        <span key={index}>
                                                            {item?.content_type}
                                                            {index !== contentTypes?.length - 1 ? ', ' : ''}
                                                        </span>
                                                    ))
                                                    : ' '
                                            }
                                        </TableCell>
                                        <TableCell className='table-row-data no-border' >
                                            <Box>
                                                <img
                                                    src={row.image}
                                                    width="40px"
                                                    height="40px"
                                                    alt="No Image"
                                                    className='br-50'
                                                />
                                            </Box>
                                        </TableCell>
                                        <TableCell className='table-row-data no-border' >
                                            <Box className="flex-row-center gap-4" >
                                                <Box className="padding-10px icon">
                                                    <Trash color='#667085' onClick={()=> dispatch(deleteCustomerSettings({customerId:row.id}))}/>
                                                </Box>
                                                <Box className="padding-10px icon">
                                                    <Edit color='#667085' onClick={()=>handleShowModal("Edit", row)}/>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow >
                                </>
                                    );
                                })
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            <CustomModal
                modalOpen={showModal}
                component={
                    <UploadAsset
                        handleClose={()=>handleShowModal()}
                        type={title}
                    />
                }
                onClose={()=>handleShowModal()}
            />
        </Box > :
        <Box className="box-sizing-border-box border-1-gray br-8px flex-row-center" height={200}>
            <Typography className="text-lg-medium gray-900 text-center">
                Please choose Campaign Generation Type as "ALGORITHM" to see the List Of Assets details.
            </Typography>
        </Box>
        }
        </>
        
    )
}

export default AssetsList